import { render } from "./MiniParagraph.vue?vue&type=template&id=7714d96b&scoped=true"
import script from "./MiniParagraph.vue?vue&type=script&lang=js"
export * from "./MiniParagraph.vue?vue&type=script&lang=js"

import "./MiniParagraph.vue?vue&type=style&index=0&id=7714d96b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7714d96b"]])

export default __exports__